
import { useState } from "react";
import type { Program } from "@/types/program";

export function useProgramsSelection(programs: Program[]) {
  const [selectedPrograms, setSelectedPrograms] = useState<string[]>([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Define filteredPrograms based on the search query
  const filteredPrograms = programs.filter(program => 
    program.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const toggleProgramSelection = (programId: string, e: React.MouseEvent<Element, MouseEvent>) => {
    e.stopPropagation();
    
    setSelectedPrograms(prev => {
      if (prev.includes(programId)) {
        return prev.filter(id => id !== programId);
      } else {
        return [...prev, programId];
      }
    });
  };

  const toggleSelectAll = () => {
    if (selectedPrograms.length === filteredPrograms.length) {
      setSelectedPrograms([]);
    } else {
      setSelectedPrograms(filteredPrograms.map(program => program.id));
    }
  };

  return {
    searchQuery,
    setSearchQuery,
    selectedPrograms,
    filteredPrograms,
    toggleProgramSelection,
    toggleSelectAll
  };
}
